import React from 'react';
import { ShareExperienceSignUp } from 'components/layout/forms';
import { PageWrapper2 } from 'components/modules/Wrapper2';
// import { home } from 'assets/images';
function ShareExperienceSignUpView() {
	return (
		<div className='bg-[#0E1022]'>
			<PageWrapper2>
				<div>
					<ShareExperienceSignUp />
				</div>
			</PageWrapper2>
		</div>
	);
}

export default ShareExperienceSignUpView;
